import React from "react";

function MainContent({ title, description, url, btnText }) {
  return (
    <div className="main-content">
      <h1>{title}</h1>
      <p>{description}</p>
      <a href={url} className="link-btn">
        {btnText}
      </a>
    </div>
  );
}

export default MainContent;
